import BaseService from '../base';

class Afp extends BaseService {}

export default new Afp('afps', 'Afp');
